import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { money } from "@/lib/daytime";

const Stat = ({ l, v, t }) => (
  <div className="bg-white rounded-2xl border border-slate-200 p-3"><p className="text-[11px] uppercase tracking-wider text-slate-400">{l}</p><p className="font-display font-black text-navy text-xl" data-testid={t}>{v}</p></div>
);

export function DaytimeReports() {
  const [period, setPeriod] = useState("week");
  const [day, setDay] = useState(new Date().toLocaleDateString("en-CA", { timeZone: "Atlantic/Bermuda" }));
  const [r, setR] = useState(null);
  useEffect(() => {
    let live = true;
    api.get("/daytime/admin/reports", { params: { period, day } }).then((x) => { if (live) setR(x.data); }).catch((e) => toast.error(apiErr(e)));
    return () => { live = false; };
  }, [period, day]);
  return (
    <div className="space-y-4 mt-3" data-testid="dt-reports">
      <div className="flex flex-wrap gap-2 items-center">
        {[["day", "Daily"], ["week", "Weekly"], ["month", "Monthly"]].map(([k, l]) => (
          <button key={k} onClick={() => setPeriod(k)} className={`px-4 py-2 rounded-full border text-sm font-bold ${period === k ? "bg-navy text-white border-navy" : "border-slate-200"}`} data-testid={`report-${k}`}>{l}</button>))}
        <Input type="date" value={day} onChange={(e) => setDay(e.target.value)} className="w-44 rounded-xl" data-testid="report-date" />
        {r && <span className="text-xs text-slate-500">{r.start} → {r.end}</span>}
      </div>
      {r && <>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
          <Stat l="Bookings" v={r.bookings} t="rep-bookings" /><Stat l="Children attending" v={r.children} t="rep-children" />
          <Stat l="Revenue (booked)" v={money(r.revenue)} t="rep-revenue" /><Stat l="Avg booking value" v={money(r.average_booking_value)} t="rep-avg" />
          <Stat l="Most popular pass" v={r.popular_label || "—"} t="rep-popular" /><Stat l="Capacity used" v={`${r.capacity_utilization}%`} t="rep-capacity" />
          <Stat l="Membership sales" v={`${r.membership_sales.count} · ${money(r.membership_sales.amount)}`} t="rep-members" />
          <Stat l="Rock Pass sales" v={`${r.rock_pass_sales.count} · ${money(r.rock_pass_sales.amount)}`} t="rep-rockpass" />
          <Stat l="Supervision revenue" v={money(r.supervision_revenue)} t="rep-sup" /><Stat l="Transport revenue" v={money(r.transport_revenue)} t="rep-transport" />
          <Stat l="Families / repeat" v={`${r.families} / ${r.repeat_customers}`} t="rep-repeat" /><Stat l="No-shows" v={r.no_shows} t="rep-noshow" />
        </div>
        <div className="bg-white rounded-2xl border border-slate-200 p-4 text-sm">
          <p className="font-bold text-navy mb-1">By pass</p>
          {Object.entries(r.by_pass).map(([k, v]) => <p key={k} className="flex justify-between"><span>{k}</span><b>{v}</b></p>)}
          {!Object.keys(r.by_pass).length && <p className="text-slate-400">No bookings in this period.</p>}
        </div>
        <p className="text-[11px] text-slate-400">Revenue is the booked value (passes, supervision, transport, passes & memberships sold); confirm collected payments in Orders.</p>
      </>}
    </div>
  );
}
